export default "__VITE_PUBLIC_ASSET__f2699457__"